function convertBackslashes(str: string | undefined): string {
  if (!str) {
    return '';
  }

  return str.replace(/\\/g, '/');
}

export function getClipKey(nodeId: string, projectPath: string): string {
  return convertBackslashes(projectPath) + '|' + nodeId;
}

export function getSequenceKey(sequenceId: string, projectPath: string): string {
  return sequenceId + '|' + convertBackslashes(projectPath);
}
